const { get } = require('lodash');

module.exports = function(value) {
  const items = get(value, 'value');
  if (!items || !Array.isArray(items.records)) {
    return {
      records: []
    };
  }
  return items;
};
